import { useEffect, useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";

import FontAwesomeIcon from "components/FontAwesomeIcon";

import styles from "./styles.module.scss";

type TextFilterInputProps = {
  value?: string;
  onChange: (_value: string) => void;
  minLength?: number;
  placeholder?: string;
};

const TextFilterInput = ({
  value,
  onChange,
  minLength = 3,
  placeholder,
}: TextFilterInputProps) => {
  const [preValue, setPreValue] = useState(value || "");
  const [filterTxtValue, setFilterTxtValue] = useState(value || "");
  const [filterTxtError, setFilterTxtError] = useState(
    "Please enter at least 3 characters"
  );

  useEffect(() => {
    if (value !== preValue) {
      setPreValue(value || "");
      setFilterTxtValue(value || "");
    }
  }, [preValue, value]);

  useEffect(() => {
    if (filterTxtValue?.length >= minLength) {
      onChange(filterTxtValue);
      setFilterTxtError("");
    } else {
      onChange("");
      setFilterTxtError(
        `Please enter at least ${minLength} character${
          minLength > 1 ? "s" : ""
        }`
      );
    }
  }, [filterTxtValue, minLength, onChange]);

  return (
    <div className={styles.filterBox}>
      <FontAwesomeIcon icon={faSearch} />
      <OverlayTrigger
        placement="bottom"
        overlay={filterTxtError ? <Tooltip>{filterTxtError}</Tooltip> : <></>}
      >
        <input
          autoComplete="false"
          autoCapitalize="false"
          value={filterTxtValue}
          onChange={(e) => setFilterTxtValue(e.target.value)}
          aria-label="filter"
          placeholder={placeholder}
        />
      </OverlayTrigger>
    </div>
  );
};

export default TextFilterInput;
